import { render } from "./Modal.vue?vue&type=template&id=1891bf13&scoped=true"
const script = {}

import "./Modal.vue?vue&type=style&index=0&id=1891bf13&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1891bf13"]])

export default __exports__